import React from 'react';

import LoansTable from '../../../../LoansTable';

import LenderService from '../../../../../services/LenderService';
import { useServicerStore } from '../../../../../store';
import usePagination from '../../../../../hooks/usePagination';

export default function Loans({ lenderId }) {
  const userRole = useServicerStore((state) => state.userRole);
  const isLender = userRole === 'lender';

  /*  const { data: loans, isFetching } = useQuery({
    queryKey: ['loans', lenderId],
    queryFn: isLender
      ? () => LenderService.getLenderLoansForLender(lenderId)
      : () => LenderService.getLenderLoans(lenderId),
    enabled: !!lenderId,
  });
 */

  const {
    currentPage,
    switchToPage,
    pageTotal,
    isFetching,
    data: loans,
  } = usePagination({
    queryKey: ['lenderInsurances', lenderId],
    queryFn: isLender
      ? LenderService.getLenderLoansForLender
      : LenderService.getLenderLoans,
    queryFnArgs: { lenderId },
    enabled: !!lenderId,
  });

  return (
    <div className="flex">
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        <div className="w-full max-w-9xl mx-auto">
          <LoansTable
            rows={loans?.items}
            isFetching={isFetching}
            pageTotal={pageTotal}
            switchToPage={switchToPage}
            currentPage={currentPage}
            isLenderSection
          />
        </div>
      </div>
    </div>
  );
}
